import React from 'react'
import { Button, Icon, TextArea } from 'semantic-ui-react'

interface OptionalTextAreaProps {
  isEditing: boolean
  onClick: () => void
  onChange: (x: string) => void
  inputName: string
  value: string
}

const OptionalTextArea = (props: OptionalTextAreaProps) => {
  const { inputName, isEditing, onClick, onChange } = props
  return (
    <div>
      <div>
        <Button
          color="teal"
          icon
          onClick={() => onClick()}
          size="huge"
          style={{
            marginRight: 50,
            opacity: isEditing ? '1' : '.5',
          }}
        >
          <Icon name={isEditing ? 'cancel' : 'pencil'} />
          {isEditing ? 'Cancel edit ' : `Edit ${inputName}`}
        </Button>
        <TextArea
          data-testid="bulk-edit-new-description"
          onChange={(e, { value }) => value && onChange(value?.toString())}
          placeholder="Enter your amazing product description..."
          rows={6}
          style={{
            display: isEditing ? '' : 'none',
          }}
          value={props.value}
        />
      </div>
    </div>
  )
}

export default OptionalTextArea
